var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 22C4.85418 22 2 19.0899 2 15.5C2 11.9101 4.85418 9 8.375 9C11.7899 9 14.5777 11.7377 14.7423 15.1779C15.0163 15.1053 15.3037 15.0667 15.6 15.0667C17.4778 15.0667 19 16.6187 19 18.5333C19 20.4479 17.4778 22 15.6 22H8.375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07178 7.53077C12.475 7.83283 15.233 10.3268 16.0223 13.5847C16.8554 13.6564 17.6252 13.9382 18.2831 14.3757C20.4805 13.3331 22 11.094 22 8.5C22 8.19925 21.5492 8.14954 21.3937 8.40695C20.6538 9.63141 19.31 10.45 17.775 10.45C15.4416 10.45 13.55 8.5584 13.55 6.225C13.55 4.69 14.3686 3.34619 15.5931 2.6063C15.8505 2.45076 15.8008 2 15.5 2C12.2395 2 9.53975 4.40063 9.07178 7.53077Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudMoon);
export default __webpack_public_path__ + "static/media/cloud-moon.8b525696d268915087f8f6333e0b9366.svg";
export { ForwardRef as ReactComponent };